/**
 * "Kort oppsummert" read-more toggle.
 * Collapses the box content behind a gradient fade and expands it on click of
 * the "Vis mer" button (which then becomes "Vis mindre"). If the content is too
 * short to need collapsing, the fade and button are removed.
 */
(function () {
	'use strict';

	function initReadmore() {
		var boxes = document.querySelectorAll('[data-readmore]');

		Array.prototype.forEach.call(boxes, function (box) {
			var content = box.querySelector('[data-readmore-content]');
			var toggle = box.querySelector('[data-readmore-toggle]');
			if (!content || !toggle) {
				return;
			}

			var labelMore = toggle.getAttribute('data-label-more') || 'Vis mer';
			var labelLess = toggle.getAttribute('data-label-less') || 'Vis mindre';

			// If the content already fits within the collapsed height, there is
			// nothing to expand - drop the fade and hide the button.
			var collapsedMax = parseInt(window.getComputedStyle(content).maxHeight, 10);
			if (!isNaN(collapsedMax) && content.scrollHeight <= collapsedMax + 4) {
				box.classList.add('is-static');
				toggle.style.display = 'none';
				return;
			}

			function setState(expanded) {
				box.classList.toggle('is-expanded', expanded);
				toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
				toggle.textContent = expanded ? labelLess : labelMore;

				// Page height changes - let GSAP ScrollSmoother recalculate.
				if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
					window.ScrollTrigger.refresh();
				}
			}

			toggle.addEventListener('click', function (e) {
				e.preventDefault();
				setState(!box.classList.contains('is-expanded'));
			});

			toggle.addEventListener('keydown', function (e) {
				if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
					e.preventDefault();
					setState(!box.classList.contains('is-expanded'));
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initReadmore);
	} else {
		initReadmore();
	}
})();
